import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import privateLibraryActions from 'redux/actions/privateLibraryActions'
import entityTypes from 'helpers/enums/entityTypes'
import { localize } from 'helpers/translator'

const deleteLessonIcon = <svg height="28" width="25" viewBox="0 0 25 28"><g fill="none"><path d="M12.653.83l.016 4.73c0 .454.38.83.843.834l4.563.053c.028 0 .052-.007.08-.01v5.577H8.874l-.718-.637H16.2c.197 0 .356-.16.356-.356v-.143c0-.196-.16-.356-.355-.356H7.98c-.198 0-.357.16-.357.357v.028L6.603 10c-.112-.1-.258-.154-.41-.163C6.14 5.514 6.083.83 6.08.83h6.573zm2.76 2.533l2.115 2.247-4.005-.046c-.002 0-.015-2.698-.022-4.083l1.913 1.883zm5.058 8.65H19V5.718l-2.977-2.93-2.355-2.5c-.127-.136-.27-.202-.41-.22L13.193 0H6.08c-.465 0-.84.372-.834.83l.105 9H2.876V2.804h1.213c.234 0 .423-.186.423-.416 0-.23-.188-.416-.422-.416H2.452c-.233 0-.422.186-.422.415v7.44H.783c-.37 0-.783.183-.783.545v13.81c0 .36.412.764.783.764H20.47c.37 0 .56-.404.56-.766V12.56c0-.362-.19-.546-.56-.546z" fill="#FFCF74"/><path d="M7.98 6.465h3.73c.197 0 .357-.16.357-.356v-.145c0-.197-.16-.356-.356-.356H7.98c-.198 0-.357.158-.357.355v.144c0 .196.16.355.356.355M7.98 8.95h8.22c.197 0 .357-.16.357-.357V8.45c0-.197-.16-.357-.356-.357H7.98c-.198 0-.357.16-.357.356v.143c0 .197.16.356.356.356" fill="#FFCF74"/><path d="M13 27.96h12v-12H13" fill="#F26C59"/><path d="M14.986 22.97h8v-1.01h-8" fill="#FFF"/></g></svg>

const PrivateLibraryDeleteLessonMultipleSchoolsConfirm = props => {
	const isBundle = props.entityType === entityTypes.BUNDLE
	return (<Confirm
		btOne = {localize('delete_single_library_option')}
		btTwo = {localize('delete_multiple_libraries_option')}
		alertTitle = {isBundle ? localize('delete_bundle_title') : localize('delete_lesson_title')}
		alertMessage = {isBundle ? localize('delete_bundle_multiple_school_message') : localize('delete_lesson_multiple_school_message')}
		alertIcon = {deleteLessonIcon}
		actionButtonType = {1}
		actionOne = {props.actions.deleteSingleLibrary}
		actionTwo = {props.actions.deleteMultipleLibraries}
		closeAction = {props.actions.cancel} />)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		deleteSingleLibrary: privateLibraryActions.deleteLesson_confirm,
		deleteMultipleLibraries: privateLibraryActions.deleteLesson_multipleSchools_confirm,
		cancel: privateLibraryActions.deleteLesson_multipleSchools_cancel,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(PrivateLibraryDeleteLessonMultipleSchoolsConfirm)
